import React, { useEffect,useState } from 'react'
import _ from 'lodash';

import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectDomainsListItems, selectDomainsQueryItems } from '../../../../../redux/domains/selector';
import { domains } from '../../../../../redux/domains/action';
import DomainComponent from '../components/domain.component';
import PageLoader from '../../../../../components/PageLoader';


const OpenNetworkDomain= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectDomainsQueryItems)
  const domainItems = useSelector(selectDomainsListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedDomain,
    setSelectedDomain
  ] = useState<any>([])
 
  const parentDomain = domainItems?.result?.items.filter(
    (subDomainData: any) => subDomainData.IsSubDomain === false
  )
  const fetchDomainById= ()=>{
    dispatch(domains.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains/query`,entity:'domains',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDomain({ ...selectedDomain, [field]: event });
  }

  useEffect(
    () => {
     
      if (parmas?.id > 0) {
        fetchDomainById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDomain(queryItems?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(domains.resetAction({ actionType: 'update' }))
     await dispatch(domains.update({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains`,entity:'domains',jsonData:{
          
    Records: [
      {
        
       
         ...selectedDomain
        
    
     
    }
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(domains.resetAction({ actionType: 'create' }))
      await dispatch(domains.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains`,entity:'domains',jsonData:{
          
      Records: [
        {
        
         
            ...selectedDomain
          
      
       
      }
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/platform-management/domains')
} 

    return (
    <>
       {isLoading ? <PageLoader /> : 
          <DomainComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedDomain={selectedDomain}
           parentDomain={parentDomain}
           back={back}
           handleFormSubmit={handleFormSubmit}
          /> 
    } 
          </>
    )
    
    }
   
    export default OpenNetworkDomain;
